import {resolveUrl, default as stipulate} from 'stipulate';
import joinUrl from '../utils/join-url';

const PUBLIC_API_GATEWAY_ENDPOINT = '/checkoutservice/pb/products/prices/';
const LEGACY_ENDPOINT = '/productservice/v2/purchasable-product-types/';

const makeGetRequest = (url, query, credentials) => {
  const urlWithQuery = resolveUrl(url, query);
  const requestOptions = {
    credentials,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    method: 'GET'
  };

  return stipulate(urlWithQuery, requestOptions);
};

const productsTree = (apiUrl) => (options, query) => {
  if (apiUrl) {
    const url = joinUrl(apiUrl, PUBLIC_API_GATEWAY_ENDPOINT);

    return makeGetRequest(url, query, 'include');
  } else {
    return makeGetRequest(LEGACY_ENDPOINT, query, 'same-origin');
  }
};

export default productsTree;
